<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>课程顾问跟进数据</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div @keyup.enter="search">
      <div class="desc-wrap">
        <span>注册名单:{{details.totalListNum}}</span>
        <span>名单数:{{details.totalUserCount}}</span>
        <span>邀约数:{{details.inviteListNum}}</span>
        <span>出席数:{{details.attendNum}}</span>
        <span>成交数:{{details.dealNum}}</span>
        <span>邀约率:{{details.inviteRate + '%'}}</span>
        <span>出席率:{{details.attendRate + '%'}}</span>
        <span>成交率:{{details.dealRate + '%'}}</span>
      </div>
      <Form :label-width="80" :show-message="false" ref="modalForm" class="form"
          :model="formData" :rules="formRule" label-position="left">
        <Row :gutter="32">
          <Col :span="5">
          <Form-item label="时间" :label-width="50">
            <Row>
              <Col span="11">
              <Date-picker v-model="dateRange" format="yyyy-MM-dd" :clearable="false" type="daterange"
                           placement="bottom-start" placeholder="选择日期" style="width: 200px"
                           @on-change="onDateChange"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col :span="5">
          <Form-item label="名单来源">
                <Select v-model.number="queryParam.assignType" placeholder="全部"
                      clearable @on-change="search">
                <Option v-for="item in $constant.assignList"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
          </Form-item>
          </Col>
          <Col :span="5">
          <Form-item label="课顾分组">
                <Select v-model="queryParam.teamType" @on-change="onTeamTypeChange">
                  <Option v-for="item in formData.adviserGroupList" :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
          </Form-item>
          </Col>
          <Col :span="5">
          <Form-item label="课程顾问">
                <Input placeholder="支持模糊搜索" name="adviserName"
                   v-model="queryParam.adviserName"></Input>
          </Form-item>
          </Col>
          <Col :span="2">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
          </Col>
          <!-- <div style="font-size: large;">七天后数据更精准</div> -->
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                  @click="exportData">导出
          </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/adminUser/listAdviserData"
          :params="queryParam" :pageSize="50" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>
  import dateFormat from '@/tools/date/format.js'
  import dates from '@/tools/date/dates.js'
  export default {
    data () {
      return {
        dateRange: [],
        exportLoading: false,
        searchLoading: false,
        reload: 0,
        queryParams: {
          studyAdviserId: null,
        },
        queryParam: {
          startTime: '',
          endTime: '',
          pageSize: 100
        },
        formData: {
          totalNum: 0,
          remainder: 0,
          teamType: 0,
          adviserGroupList: this.$constant.adviserGroup,
          adviserList: [],
        },
        formRule: {

        },
        details: '',
        title: [
          // {
          //   title: 'ID',
          //   width: 100,
          //   key: 'adviserId',
          // },
          {
            title: '课顾',
            width: 150,
            align: 'center',
            key: 'adviserName',
            render: (h, params) => {
              let row = params.row
              if (row.state === 1) {
                return h('span', [
                  h('span', row.adviserName)
                ])
              } else {
                return h('span', [
                  h('span', row.adviserName),
                  h('span', {style: {color: 'red'}}, '(离职)')
                ])
              }
            }
          },
          {
            title: '外呼次数',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.outerCallNum)
            }
          },
/*          {
            title: '外呼量',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('span', row.outerCallTime.toFixed(2))
            }
          },
          */
          {
            title: '接听量',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.answerTime.toFixed(2))
            }
          },
          {
            title: '通时',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.callTime.toFixed(2))
            }
          },
          {
            title: '名单数',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
//              return h('a', {on: {click: () => this.showAssignDetail(row.adviserId)}}, row.totalListNum)
              return h('span', row.totalListNum)
            }
          },
          {
            title: '邀约数',
            width: 100,
            align: 'center',
            key: 'inviteListNum',
            render: (h, params) => {
              let row = params.row
//              return h('a', {on: {click: () => this.showDetails(row.adviserId, 1)}}, row.inviteListNum)
              return h('span', row.inviteListNum)
            }
          },
          {
            title: '邀约率',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.inviteRate.toFixed(2) + '%')
            }
          },
          {
            title: '出席数',
            key: 'attendNum',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
//              return h('a', {on: {click: () => this.showDetails(row.adviserId, 2)}}, row.attendNum)
              return h('span', row.attendNum)
            }
          },
          {
            title: '出席率',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.attendRate.toFixed(2) + '%')
            }
          },
          {
            title: '成交数',
            key: 'dealNum',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
//              return h('a', {on: {click: () => this.showDetails(row.adviserId, 3)}}, row.dealNum)
              return h('span', row.dealNum)
            }
          },
/*          {
            title: '总成交率',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('span', row.dealRate.toFixed(2) + '%')
            }
          },
          */
          {
            title: '注册成交率',
            width: 110,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.payUserRate.toFixed(2) + '%')
            }
          },
          {
            title: '出席成交率',
            width: 110,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.attendDealRate.toFixed(2) + '%')
            }
          },
          {
            title: '目标(单)',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.orderQuantity)
            }
          },
          {
            title: '完成量(单)',
            width: 110,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.finishOrderQuantity)
            }
          },
          {
            title: '成交金额',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.dealMoney)
            }
          },
          {
            title: '完成率',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.finishRate.toFixed(2) + '%')
            }
          },
        ]
      }
    },
    methods: {
      getAdviserList (teamType) {
        let self = this
        self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
          if (res && res.data) {
            self.formData.adviserList = res.data
          }
        })
      },
      onTeamTypeChange (value) {
        this.getAdviserList(value)
      },
      onDateChange (dateRange) {
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = Date.parse(new Date(value)) / 1000
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = Date.parse(new Date(value)) / 1000
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      search () {
        let self = this
        let startTimeDate = dates.format(this.dateRange[0])
        let endTimeDate = dates.format(this.dateRange[1])
        self.queryParam.startTime = Date.parse(startTimeDate) / 1000
        self.queryParam.endTime = Date.parse(endTimeDate) / 1000
        this.$http.post('/adminUser/getTotalAdviserData', self.queryParam).then(function (res) {
          self.details = res.data
        })
        self.reload = new Date().getMilliseconds()
      },
      showAssignDetail (id) {
        localStorage.setItem('adviserId', id)
        localStorage.setItem('startTime', this.queryParam.startTime)
        localStorage.setItem('endTime', this.queryParam.endTime)
        this.$router.push({path: '/data/showAssignDetail'})
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/adminUser/exportAdviserData', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '课程顾问汇总数据.csv'
          link.click()
          this.exportLoading = false
        }).catch((e) => {
          this.exportLoading = false
        })
      },
      showDetails (id, cmd) {
        localStorage.setItem('adviserId', id)
        localStorage.setItem('startTime', this.queryParam.startTime)
        localStorage.setItem('endTime', this.queryParam.endTime)
        localStorage.setItem('cmd', cmd)
        this.$router.push({path: '/data/showAdviserDataDetail'})
      }
    },
    mounted: function () {
      let self = this
      this.$http.post('/adminUser/getTotalAdviserData', self.queryParam).then(function (res) {
        self.details = res.data
      })
    },
    created: function () {
      let week = new Date().getDay()
      let left = week
      if (week === 0) {
        left = 7
      }

      let self = this
      let now = Date.now()
      this.dateRange[0] = dateFormat(new Date(now - (left + 6) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD')
      this.dateRange[1] = dateFormat(new Date(now - (left) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD')
      let startTimeDate = dates.format(this.dateRange[0])
      let endTimeDate = dates.format(this.dateRange[1])
      self.queryParam.startTime = Date.parse(startTimeDate) / 1000
      self.queryParam.endTime = Date.parse(endTimeDate) / 1000
    }
  }
</script>


<style lang="less" scoped>
  .desc-wrap {
    display: flex;
    margin-top: 15px;
    margin-bottom: 10px;
    font-size: small;
    span {
      margin-right: 20px;
    }
  }
  .btn-wrap {
    text-align: right;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// AdviserData.vue?738a9921